'use client';

import { useTranslation } from '../../kit/useTranslation';

export default function AboutContent() {
  const { t } = useTranslation();

  return (
    <>
      <h1>{t('about.title')}</h1>
      <p>{t('about.comingSoon')}</p>
    </>
  );
}
